export default function addMetaDescription(description) {
  const tag = document.createElement('meta')

  tag.setAttribute('description', description)
  tag.setAttribute('og:description', description)
  tag.setAttribute('data-vue-router-controlled', '')

  document.head.appendChild(tag)
}
